// src/components/ContactModal.js

import React from "react";
import { FaPhoneAlt, FaWhatsapp, FaTimes } from "react-icons/fa";
import { useTranslation } from "react-i18next";

const ContactModal = ({ isOpen, onClose, contactNumber, packageName }) => {
  const { t } = useTranslation();

  if (!isOpen) {
    return null;
  }

  // Sanitize phone number for WhatsApp link (removes '+', spaces, etc.)
  const whatsAppNumber = contactNumber.replace(/[^0-9]/g, "");

  // Create a pre-filled message for WhatsApp
  const whatsAppMessage = encodeURIComponent(
    `Hello, I'm interested in the "${packageName}" package.`
  );

  return (
    <div className="contact-modal-overlay" onClick={onClose}>
      <div
        className="contact-modal-content"
        onClick={(e) => e.stopPropagation()}
      >
        <button className="contact-modal-close-btn" onClick={onClose}>
          <FaTimes />
        </button>
        <div className="contact-modal-body">
          <h3>{t("Contact Us")}</h3>
          <p>
            {t("You selected the package of")} <strong>{packageName}</strong>
            {". "}
            {t("How would you like to contact us?")}
          </p>
        </div>
        <div className="contact-modal-actions">
          <a
            href={`tel:${contactNumber}`}
            className="contact-modal-button call"
          >
            <FaPhoneAlt />
            <span>{t("Call Us")}</span>
          </a>
          <a
            href={`https://wa.me/${whatsAppNumber}?text=${whatsAppMessage}`}
            target="_blank"
            rel="noopener noreferrer"
            className="contact-modal-button whatsapp"
          >
            <FaWhatsapp />
            <span>{t("Contact via WhatsApp")}</span>
          </a>
        </div>
      </div>
    </div>
  );
};

export default ContactModal;
